import { OrderingInitialState, SetDefaultDescriptionAction } from '@reducers/ordering/types';

export const setDefaultDescription = (
  state: OrderingInitialState,
  action: SetDefaultDescriptionAction
): OrderingInitialState => ({
  ...state,
  orderState: {
    ...state.orderState,
    defaultDescriptions: action.payload.defaultDescriptions,
  },
});
